<template>
    <DuplicateHandler></DuplicateHandler>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const DuplicateHandler = defineAsyncComponent(() =>
    import("../../components/Design/DuplicateHandler.vue")
);

export default {
    name: "DuplicateHandlerPage", //The name you are in should not equal the name of the component you are importing.
    components: { DuplicateHandler, AuthLayout },
};
</script>
